import styled from 'styled-components'

export const IntroServiceWrapper = styled.div`
  padding: 0 32px;
  @media only screen and (max-width: 768px) {
    padding: 0 16px;
  }
`
export const IntroText = styled.div`
  font-weight: 600;
  font-size: 20px;
  color: #2E2E2E;
  margin-top: 16px;
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`